<script>
  import { onMount } from 'svelte';
  import { MDCTabBar } from '@material/tab-bar';

  // component options  ------------------------------------------------------ //

  export let tab_bar_items;
  export let current_tab;
  export let padding;
  export let validate = false;
  export let is_team_selector_opened;


  // internal variables ------------------------------------------------------ //

  let tabBar;

  // utility functions -------------------------------------------------------- //

  const animateHeight = () => {
    setTimeout(function() {
      let outer = document.querySelector('#transition-outer');
      let inner = document.querySelector('#transition-inner');
      if (inner) {
        let innerHeight = inner.clientHeight;
        outer.style.height = innerHeight + 'px';
      }
    }, 550);
  };

  const init_tab_bar = () => {
    tabBar = new MDCTabBar(document.querySelector('.mdc-tab-bar'));
    let tabs = document.querySelectorAll('.mdc-tab');
    tabBar.listen('MDCTabBar:activated', event => {
      if (validate === false) {
        let tab = tabs[event.detail.index];
        current_tab = event.detail.index;
        // animateHeight();
      } else {
        let tab = tabs[event.detail.index];
        current_tab = event.detail.index;
        // animateHeight();
        // let tab = tabs[event.detail.index];
        // if(validated_tabs.length === 0){
        //     current_tab = 0;
        // } else{
        //     current_tab = validated_tabs[validated_tabs.length - 1];
        // }
      }

      let connection =
        navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection;
      if (
        typeof connection === 'object' &&
        'effectiveType' in connection &&
        connection.effectiveType === '4g'
      ) {
        // animateHeight();
      }
    });
    // window.addEventListener( 'load', () => { animateHeight() }, false );
  };

  onMount(init_tab_bar);

  // reactive functions ------------------------------------------------------- //

  // $: if(is_team_selector_opened) animateHeight();
  $: if (tabBar) tabBar.activateTab(current_tab);
</script>

<div class="mdc-tab-bar" role="tablist">
  <div class="mdc-tab-scroller">
    <div class="mdc-tab-scroller__scroll-area">
      <div
        class="mdc-tab-scroller__scroll-content"
        style={`padding: 0px ${padding} 0px ${padding}`}>

        {#each tab_bar_items as items, i}
          <button
            class="mdc-tab "
            class:mdc-tab--active={i === 0}
            class:btn-disabled={validate && !items.validated}
            role="tab"
            id={'tab_btn-' + i}
            aria-selected="true"
            tabindex="0">
            <span class="mdc-tab__content">
              {#if items.icon !== null}
                <span class="mdc-tab__icon material-icons" aria-hidden="true">
                  {items.icon}
                </span>
              {/if}

              <span
                class="mdc-tab__text-label"
                class:color={current_tab !== i && !items.validated}>
                {items.name}
              </span>
            </span>
            <span
              class="mdc-tab-indicator "
              class:mdc-tab-indicator--active={i === 0}>
              <span
                class="mdc-tab-indicator__content
                mdc-tab-indicator__content--underline" />
            </span>
            <span class="mdc-tab__ripple" />
          </button>
        {/each}
      </div>
    </div>
  </div>
</div>

<style>
  .btn-disabled {
    pointer-events: none;
    cursor: not-allowed;
  }

  .btn-disabled .color {
    color: #bfbfbf;
  }
</style>
